import { ModalWrapper, NewModalBodyWrapper, PageHeader, SmallContentContainer } from '@mews-commander/ui';

type IntegrationSettingsBaseLayoutProps = Pick<React.ComponentProps<typeof PageHeader>, 'breadcrumbs' | 'actions'>;

export const IntegrationSettingsBaseLayout = ({
    breadcrumbs = [],
    actions,
    children,
}: React.PropsWithChildren<IntegrationSettingsBaseLayoutProps>) => (
    <ModalWrapper>
        <PageHeader breadcrumbs={breadcrumbs} actions={actions} />
        <NewModalBodyWrapper>
            <SmallContentContainer>{children}</SmallContentContainer>
        </NewModalBodyWrapper>
    </ModalWrapper>
);
